import React from "react";
import { Button, Modal, Tag } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import { toFa } from "../../utils/helpers";
import styles from "./styles.module.css";

/* Shows what a starter template actually contains before it is applied.
 *
 * The columns and tasks come straight off the template record, so this is the
 * real board the project will be created with — not an illustration that can
 * drift from what the API builds. */
const TemplatePreviewModal = ({ template, open, onClose, onSelect }) => {
  const steps = template?.steps || [];
  const backlog = template?.tasks || [];

  const totalTasks =
    backlog.length +
    steps.reduce((sum, step) => sum + (step?.tasks?.length || 0), 0);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={720}
      centered
      destroyOnClose
      title={
        <div className={styles.previewTitle}>
          <strong>{template?.title}</strong>
          <span>
            {toFa(steps.length)} ستون · {toFa(totalTasks)} تسک آماده
          </span>
        </div>
      }
    >
      {template?.description ? (
        <p className={styles.previewDescription}>{template.description}</p>
      ) : null}

      <div className={styles.previewBoard}>
        {steps.map((step, index) => {
          const tasks = [
            ...(step?.tasks || []),
            /* Template-level tasks are the backlog: the API drops them into the
             * first column, so the preview has to show them there too. */
            ...(index === 0 ? backlog : []),
          ];

          return (
            <div className={styles.previewColumn} key={`${step?.title}-${index}`}>
              <div className={styles.previewColumnHead}>
                <span
                  className={styles.previewDot}
                  style={{ background: step?.color_code || "var(--ds-accent)" }}
                />
                <span className={styles.previewColumnTitle}>{step?.title}</span>
                <Tag className={styles.previewCount}>{toFa(tasks.length)}</Tag>
              </div>
              <div className={styles.previewTasks}>
                {tasks.length ? (
                  tasks.map((task, taskIndex) => (
                    <div
                      className={styles.previewTask}
                      key={`${task?.title}-${taskIndex}`}
                    >
                      {task?.title}
                    </div>
                  ))
                ) : (
                  <span className={styles.previewEmpty}>خالی</span>
                )}
              </div>
            </div>
          );
        })}
      </div>

      <div className={styles.previewFooter}>
        <Button onClick={onClose}>بی‌خیال</Button>
        <Button
          type="primary"
          icon={<CheckOutlined />}
          onClick={() => onSelect(template)}
        >
          همین رو می‌خوام
        </Button>
      </div>
    </Modal>
  );
};

export default TemplatePreviewModal;
